import { GenericStatus } from "./props";

const VesselRequisitionItemDeliveryStatus: GenericStatus[] = [
    {key: "pending", text: "Pending", tagVariant: 'warning', isDefault: true},
    {key: "completed", text: "Delivered", tagVariant: 'active'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]                                                        

export default VesselRequisitionItemDeliveryStatus;